import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Chart from "./pages/Chart";
import List from "./pages/List";
import OrderList from "./pages/OrderList";

import "./app.scss";

class App extends Component {
  render() {
    return (
      <Router>
        <div className="app-container">
          {/* Sellers */}
          <Route exact path="/sellers/:id/sales/list" component={List} />
          <Route exact path="/sellers/:id/sales/chart" component={Chart} />
          {/* Suppliers */}
          <Route exact path="/suppliers/:id/sales/list" component={List} />
          <Route exact path="/suppliers/:id/sales/chart" component={Chart} />
          <Route
            exact
            path="/suppliers/:id/orders/list"
            render={routeProps => <OrderList {...routeProps} entity="supplier" />}
          />
          <Route
            exact
            path="/suppliers/:id/orders-confirmation/list"
            render={routeProps => <OrderList {...routeProps} filterStatus={3} sendObject={true} entity="supplier"/>}
          />
          {/* Affiliates */}
          <Route exact path="/affiliates/:id/sales/list" component={List} />
          <Route exact path="/affiliates/:id/sales/chart" component={Chart} />
          <Route
            exact
            path="/affiliates/:id/orders/list"
            render={routeProps => <OrderList {...routeProps} entity="affiliate"/>}
          />
          {/* Agents */}
          <Route
            exact
            path="/agents/:id/orders/list"
            render={routeProps => <OrderList {...routeProps} sendObject={true} hideDownloadBtn={true} entity="agent"/>}
          />
          {/* Account */}
          <Route exact path="/account/:id/sales/list" component={List} />
          <Route exact path="/account/:id/sales/chart" component={Chart} />
        </div>
      </Router>
    );
  }
}

export default App;
